const Bell = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.01522 15.75C7.54407 16.2168 8.23875 16.5 8.99959 16.5C9.76042 16.5 10.4551 16.2168 10.984 15.75M13.4996 6C13.4996 4.80653 13.0255 3.66193 12.1816 2.81802C11.3377 1.97411 10.1931 1.5 8.99959 1.5C7.80611 1.5 6.66152 1.97411 5.81761 2.81802C4.97369 3.66193 4.49959 4.80653 4.49959 6C4.49959 8.31764 3.91494 9.90447 3.26184 10.9541C2.71093 11.8394 2.43548 12.2821 2.44558 12.4056C2.45676 12.5423 2.48573 12.5944 2.59592 12.6762C2.69543 12.75 3.14403 12.75 4.04123 12.75H13.9579C14.8551 12.75 15.3037 12.75 15.4033 12.6762C15.5134 12.5944 15.5424 12.5423 15.5536 12.4056C15.5637 12.2821 15.2882 11.8394 14.7373 10.9541C14.0842 9.90447 13.4996 8.31764 13.4996 6Z"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Bell;
